module.exports = __webpack_public_path__ + "static/media/forgot-password-footer.3e7fbab3.png";